import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiFacebook, FiInstagram, FiGlobe } from 'react-icons/fi';

const Footer = () => {
  // Use custom background classes for the footer
  const backgroundClass = 'bg-footer-light dark:bg-footer-dark';
  const textColorClass = 'text-text-light dark:text-text-dark';
  const location = useLocation();
  
  // Add responsive margin classes based on current route
  const marginClass = location.pathname === '/login' 
    ? 'mt-auto pt-4' 
    : 'mt-8';

  return (
    <footer className={`${backgroundClass} ${textColorClass} ${marginClass} py-6 sm:py-8 w-full`}>
      <div className="mx-4 sm:mx-8 lg:mx-16">
        <div className="container mx-auto px-2 sm:px-4">
          {/* Upper section */}
          <div className="flex flex-col md:flex-row justify-between items-center mb-4 sm:mb-8">
            {/* Logo or Branding */}
            <div className="mb-4 md:mb-0">
              <Link to="/" className="flex items-center space-x-2">
                {/* Replace with your logo */}
                <img src="/logo.png" alt="Logo" className="h-16 w-16 sm:h-20 sm:w-20" />
                <span className="font-bold text-xl">Cheverly PD</span>
              </Link>
            </div>

            {/* Social Media Icons */}
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/CheverlyPolice"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-accent-light dark:hover:text-accent-dark"
              >
                <FiFacebook size={24} />
              </a>
              <a
                href="https://www.instagram.com/cheverlypolice/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-accent-light dark:hover:text-accent-dark"
              >
                <FiInstagram size={24} />
              </a>
              <a
                href="https://www.cheverly-md.gov/606/Police"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-accent-light dark:hover:text-accent-dark"
              >
                <FiGlobe size={24} />
              </a>
            </div>
          </div>
          {/* Divider */}
          <div className="border-t border-secondary-light dark:border-secondary-dark my-3 sm:my-4"></div>
          {/* Lower section */}
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-xs sm:text-sm">
              © {new Date().getFullYear()} Cheverly PD Field Training. All rights
              reserved.
            </p>
            <div className="flex space-x-4 mt-3 md:mt-0">
              <Link
                to="/privacy-policy"
                className="text-xs sm:text-sm hover:text-accent-light dark:hover:text-accent-dark"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms-of-service"
                className="text-xs sm:text-sm hover:text-accent-light dark:hover:text-accent-dark"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
